<script setup lang="ts">
import { IItemVariantOptionValue } from '@rediredi/types'

const props = defineProps<{ optionValue: IItemVariantOptionValue; selected?: string }>()
const emit = defineEmits<{ (e: 'update:selected', name: string): void }>()
const theme = useStoreTheme()
</script>
<template>
  <RBaseButton
    link
    color="none"
    class="max-w-fit"
    @click="emit('update:selected', props.optionValue.name)"
  >
    <div
      class="flex min-h-[51px] min-w-[51px] items-center justify-center gap-2 overflow-hidden rounded-xl border-[1.5px] border-white bg-white px-4 shadow-sm"
      :class="{ 'py-1 pl-1 pr-3': props.optionValue.pictures?.length }"
      :style="{
        borderColor: props.selected === props.optionValue.name ? theme.primary : '',
      }"
    >
      <div
        v-if="props.optionValue.pictures?.length"
        class="flex h-[40px] w-[40px] items-center justify-center rounded-lg border-[0.5px] border-mercury p-1"
      >
        <RProductImage
          :picture="optimizedImage(getPictureUrl(props.optionValue.pictures[0]), 'thumb')"
        />
      </div>
      <span class="text-[13px] font-semibold text-gray-400">
        {{ props.optionValue.name }}
      </span>
    </div>
  </RBaseButton>
</template>
